module.exports = __webpack_public_path__ + "media/images/military-0b8cae04213e4e3d14b6405c2ec33ac7.jpg";